import { useAtomValueRawSync } from 'jotai';
import { useLayoutEffect } from 'react';

import { themeAtom } from '@/state/ui/themeAtoms';

import { showThemeOnPage } from './themeOnPage';

/** Puts the picked theme on the page for every route, before the paint. */
export const PageTheme = (): null => {
    const theme = useAtomValueRawSync(themeAtom);
    useLayoutEffect((): (() => void) => showThemeOnPage(theme), [theme]);
    return null;
};
